import { type SorterResult } from 'antd/es/table/interface';
import { type NotificationListParams } from '../search/NotificationListParams.ts';
import { type NotificationRecord } from './notificationColumnsBase.tsx';

export const DEFAULT_SORT_FIELD: NotificationListParams['sortField'] =
  'DATA_NOTIFICA';
export const DEFAULT_SORT_DIRECTION: NotificationListParams['sortDirection'] =
  'DESC';

interface ISortParams {
  // Campi opzionali per consentire la gestione dell'ordinamento a monte;
  // getSortParams restituisce comunque sempre sortField e sortDirection valorizzati
  sortField?: NotificationListParams['sortField'];
  sortDirection?: NotificationListParams['sortDirection'];
}

/**
 * Calcola i parametri di ordinamento dalla tabella.
 *
 * Quando Ant Design invia un sortResult vuoto (3° click in modalità controlled):
 * - Se la colonna attiva è quella di default → inverte la direzione (ASC ↔ DESC)
 * - Se la colonna attiva è un'altra → torna all'ordinamento di default
 */
export function getSortParams(
  sortResult: SorterResult<NotificationRecord>,
  query: NotificationListParams,
): ISortParams {
  if (!sortResult.order) {
    const isDefaultField =
      (query.sortField ?? DEFAULT_SORT_FIELD) === DEFAULT_SORT_FIELD;
    if (isDefaultField) {
      return {
        sortField: DEFAULT_SORT_FIELD,
        sortDirection: query.sortDirection === 'ASC' ? 'DESC' : 'ASC',
      };
    }
    return {
      sortField: DEFAULT_SORT_FIELD,
      sortDirection: DEFAULT_SORT_DIRECTION,
    };
  }
  return {
    sortField: (sortResult.column?.sortDataIndex ??
      sortResult.field ??
      DEFAULT_SORT_FIELD) as ISortParams['sortField'],
    sortDirection: sortResult.order === 'ascend' ? 'ASC' : 'DESC',
  };
}
